import { useState } from 'react';
import { noSelectionKey } from '../../../../../../../utilities/filterAndSortingsUtil';

export const useCustomSelection = () => {
  const [selectedGroupName, setSelectedGroupName] = useState(noSelectionKey);

  function isGroupSelected(groupData) {
    return groupData.groupName === selectedGroupName;
  }

  function isAnyGroupSelected() {
    return selectedGroupName !== noSelectionKey;
  }

  function onGroupClick(groupData) {
    setSelectedGroupName((prevSelectedName) => {
      if (groupData.groupName === prevSelectedName) {
        return noSelectionKey;
      } else {
        return groupData.groupName;
      }
    });
  }

  return {
    isAnyGroupSelected,
    isGroupSelected,
    onGroupClick,
    selectedGroupName,
    setSelectedGroupName,
  };
};
